import styled from 'styled-components';
import { IonSpinner } from '@ionic/react';
import { FC } from 'react';
import { AllieText } from '../../../components';

const ContentLoadingStyled = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  padding: 36px;
  box-sizing: border-box;
  width: 392px;
  margin: 0 auto;
`;

export interface EfficiencyConfirmingProps {
  text: string;
  className?: string;
}

export const EfficiencyConfirming: FC<EfficiencyConfirmingProps> = ({ text, className }) => {
  return (
    <ContentLoadingStyled className={className}>
      <IonSpinner name="circular" color="primary"></IonSpinner>
      <AllieText color="neutral-90" type="h2">
        {text}
      </AllieText>
    </ContentLoadingStyled>
  );
};
